var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showContainer)?_c('div',{staticClass:"gl-bg-gray-10 gl-p-3 md:gl-flex"},[(_vm.filteredSearchBar.show)?_c('members-filtered-search-bar',{staticClass:"gl-grow gl-p-3"}):_vm._e(),_vm._v(" "),(_vm.showSortDropdown)?_c('sort-dropdown',{staticClass:"gl-shrink-0 gl-p-3"}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }